import { createAction, props } from '@ngrx/store';
import { IPaymentRunMonthsResponse } from '../dto/payment-run-months.dto';

export const loadPaymentRunMonths = createAction('[PaymentRunMonths] Load PaymentRunMonths', props<{ businessId: string }>());

export const loadPaymentRunMonthsSuccess = createAction(
  '[PaymentRunMonths] Load PaymentRunMonths Success',
  props<{ response: IPaymentRunMonthsResponse[] }>()
);

export const loadPaymentRunMonthsFailure = createAction(
  '[PaymentRunMonths] Load PaymentRunMonths Failure',
  props<{ error: Error | any }>()
);
